module.exports = __webpack_public_path__ + "img/betterave_a_salade_md.4e4b7d83.jpg";